import { Link } from 'react-router-dom';
import ArticleLayout from '@/pages/article/components/ArticleLayout';
import Footer from '@/pages/home/components/Footer';

export default function BasetaoBeginnerGuide() {
  return (
    <>
      <ArticleLayout title="Basetao Beginner Guide 2026: Step-by-Step First Order Tutorial" subtitle="A complete beginner-friendly walkthrough for placing your first Basetao order, from account registration to receiving your package at your doorstep." tag="Beginner">
        <section className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">Getting Started with Basetao</h2>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
            If you are new to <strong className="text-foreground-900">Basetao</strong>, the process is simpler than it looks. Start by creating an account, then use the platform's search or paste product URLs from supported marketplaces. Basetao's team purchases the items on your behalf, inspects them at their warehouse, and ships everything to your international address.
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
            The key to a smooth first experience is starting with a small order &mdash; one or two items &mdash; to understand the flow before building larger hauls. Refer to the <Link to="/" className="text-primary-600 hover:text-primary-700 font-medium underline">Basetao Spreadsheet homepage</Link> to see real examples of successful first orders and avoid common pitfalls.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">First Order Checklist</h2>
          <div className="space-y-3">
            {[
              { step: '1. Create Account', detail: 'Sign up with a valid email and complete profile verification.' },
              { step: '2. Fund Wallet', detail: 'Top up your balance via supported payment methods.' },
              { step: '3. Paste Product URL', detail: 'Copy a product link from supported platforms into Basetao.' },
              { step: '4. Review QC Photos', detail: 'Inspect warehouse photos before approving international shipment.' },
              { step: '5. Choose Shipping', detail: 'Select a carrier that balances cost and speed for your region.' },
              { step: '6. Track Package', detail: 'Monitor delivery progress through the provided tracking number.' },
            ].map((s) => (
              <div key={s.step} className="flex gap-4 p-4 rounded-lg bg-background-100 border border-background-200/70">
                <div className="min-w-[130px] text-sm font-semibold text-primary-700">{s.step}</div>
                <p className="text-sm text-foreground-700">{s.detail}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mb-8">
          <div className="bg-primary-50/50 border border-primary-200/50 rounded-lg p-6 md:p-8 text-center">
            <h2 className="font-heading text-xl font-bold text-foreground-900 mb-3">Start Your Journey</h2>
            <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">Back to BasetaoSheet Home</Link>
          </div>
        </section>
      </ArticleLayout>
      <Footer />
    </>
  );
}